import script from "./MetricGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricGraph.vue?vue&type=script&setup=true&lang=js"

import "./MetricGraph.vue?vue&type=style&index=0&id=79a327d4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a327d4"]])

export default __exports__